import React, { useState } from "react";
import "./Section1.css";
import "bootstrap/dist/css/bootstrap.min.css";
import illustration from "../Asset/desktop illustration 2.png";
import plusIconBlue from "../Asset/plus icon blue.png";
import tickIconOrange from "../Asset/tick icon orange.png";
import shieldIconBlue from "../Asset/shield icon blue.png";
import plusIconOrange from "../Asset/plus icon orange.png";
import tickIconBlue from "../Asset/tick icon blue.png";
import shieldIconOrange from "../Asset/shield icon orange.png";
import Question_img from "../Asset/Question.png";
import vector_icon from "../Asset/Vector 4 .png";
import Wave from "../Asset/svgviewer-png-output.png";
import Arrow from "../Assets/Arrow.svg";
import logo1 from "../Asset/injured man illustration.png";
import logo2 from "../Asset/locker illustration.png";
import { ReactComponent as ArrowIcon } from "../Asset/up-arrow-svgrepo-com.svg";
import { Link } from "react-router-dom";
import GroupHealth from "../Assets/group health icon.svg";
import GroupPersonalAccident from "../Assets/group accident icon.svg";
import GroupTermLife from "../Assets/group term icon.svg";
import FireBulglary from "../Assets/fire & burglary icon.svg";
import OfficePackage from "../Assets/Icon office package.svg";
import ShopOwner from "../Assets/shop owner icon.svg";
import ProfDoctor from "../Assets/prof indemnity for doctors icon.svg";
import ProfCompanies from "../Assets/prof indemnity for companies icon.svg";
import Workmen from "../Assets/workmen compensation icon.svg";
import SingleTransit from "../Assets/single transit policy icon.svg";
import MarineOpen from "../Assets/marine open policy icon.svg";
import SalesTurnOver from "../Assets/sales turnover policy icon.svg";
import DirectorsOfficers from "../Assets/Directors & Office  Insurance icon.svg";
import ErrorOmmision from "../Assets/errors & omission icon.svg";
import GeneralLiability from "../Assets/general liability icon.svg";
import ProductLiabilty from "../Assets/Product Liability icon.svg";
import CyberInsurance from "../Assets/cyber icon.svg";
import CrimeInsurance from "../Assets/crime icon.svg";
import GroupGratulty from "../Assets/Group (4).svg";
import GroupCreditLife from "../Assets/Group (5).svg";
import MotorFleetInsurance from "../Assets/Group 9130.svg";
import tree from "../Assets/Group 8986.svg";
import tree1 from "../Assets/23849466_6815593 1.svg";
import innerplus from "../Assets/innerplus.svg";
const Section1 = () => {
  return (
    <div className="main">
      <div className="heading">
        <span className="small-heading mt-5 p-5"><a style={{color:'rgba(147, 147, 147, 1)'}} href="https://www.policyplanner.com/">Home</a>  &gt;<span style={{ fontWeight: '700' }}> SME </span> </span>



        <div className="Top_heading_container">
          <img src={tree} alt="Group Personal Accident" className="SME_fistimg_section1 SME_fistimg_section_desktop" />
          <div>
            <h3 className="text-black getrightHeading p-4"> Get the Right <span className="data-color">SME Insurance</span> , Right Here</h3>
            <img src={Arrow} className="arrow" alt="" class="arrow_line" />
          </div>

          <div className="Mobile_img_container_sme">
            <img src={tree1} alt="Group Personal Accident" className="SME_fistimg_section1" />
            <img src={tree} alt="Group Personal Accident" className="SME_fistimg_section1 SME_fistimg_section_mobile" />
          </div>
        </div>



      </div>

      <div className="homeBannerProduct bg-white">
        <div className="container-fluid">
          <div className="row row_container1">
            {/* Left Side - Employee & Group Benefit, Property Insurance */}
            <div className="col-12 col-md-6">
              <p className="homeBannerProduct-heading">
                Employee & Group Benefit
              </p>
              <div className="p-3">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-4">
                      <Link to="grouphealth" className="link-style">
                        <div className="image-container-fluid hover-effect" style={{ marginBottom: '3rem' }}>
                          <div className="Circle">
                            <img
                              src={GroupHealth}
                              alt="Group Health Insurance"
                            // width="49px"
                            // height="45px"
                            />
                          </div>
                          <h5>Group Mediclaim</h5>
                        </div>
                      </Link>
                    </div>

                    <div className="col-4">
                      <Link to="GroupPersonal" className="link-style">
                        <div className="image-container-fluid hover-effect">
                          <div className="Circle">
                            <img
                              src={GroupPersonalAccident}
                              alt="Group Personal Accident"
                            />
                          </div>
                          <h5>Group Personal Accident</h5>
                        </div>
                      </Link>
                    </div>
                    <div className="col-4 line">
                      <Link to="GroupTerm" className="link-style">
                        <div className="image-container-fluid hover-effect">
                          <div className="Circle">
                            <img src={GroupTermLife} alt="Group Term Life" />
                          </div>
                          <h5>Group Term Life</h5>
                        </div>
                      </Link>
                    </div>

                    <div className="col-4">
                      <Link to="GroupGratuity" className="link-style">
                        <div className="image-container-fluid hover-effect">
                          <div className="Circle">
                            <img src={GroupGratulty} alt="New Product 1" />
                          </div>
                          <h5>Group Gratuity</h5>
                        </div>
                      </Link>
                    </div>

                    <div className="col-4">
                      <Link to="GroupCredit" className="link-style">
                        <div className="image-container-fluid hover-effect">
                          <div className="Circle">
                            <img src={GroupCreditLife} alt="New Product 2" />
                          </div>
                          <h5>Group Credit Life</h5>
                          <hr className="divider" />
                        </div>
                      </Link>
                    </div>
                  </div>

                </div>
              </div>

              <p className="homeBannerProduct-heading">Property Insurance</p>
              <div className="container-fluid">
                <div className="row p-3">
                  <div className="col-4">
                    <Link to="FireBurglary" className="link-style">
                      <div className="image-container-fluid hover-effect" style={{ marginBottom: '3rem' }}>
                        <div className="Circle">
                          <img
                            src={FireBulglary}
                            alt="Fire & Burglary Insurance"
                          />
                        </div>
                        <h5 className="link-text">Fire & Burglary Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="OfficePolicy" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={OfficePackage}
                            alt="Office Package Policy"
                          />
                        </div>
                        <h5>Office Package Policy</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4 line">
                    <Link to="ShopInsurance" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img src={ShopOwner} alt="Shop Owner Insurance" />
                        </div>
                        <h5>Shop Owner Insurance</h5>
                      </div>
                    </Link>
                  </div>

                </div>
              </div>

              <p className="homeBannerProduct-heading">
                Transit and Marine Insurance
              </p>
              <div className="container-fluid container_fist_section">
                <div className="row">
                  <div className="col-4">
                    <Link to="SingleTransitInsurance" className="link-style">

                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={SingleTransit}
                            alt="Single Transit Insurance"
                          />
                        </div>
                        <h5>Marine Single Transit</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="MarineOpenInsurance" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img src={MarineOpen} alt="Marine Open Insurance" />
                        </div>
                        <h5>Marine Open Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="SalesTurnOverInsurance" className="link-style">

                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={SalesTurnOver}
                            alt="Sales Turnover Insurance"
                          />
                        </div>
                        <h5>Marine Sales Turnover Policy</h5>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>




            {/* Right Side - Liability Insurance */}
            <div className="col-12 col-md-6">
              <p className="homeBannerProduct-heading">Liability Insurance</p>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-4">
                    <Link to="ProffessionalDoctors" className="link-style">
                      <div className="image-container-fluid hover-effect" style={{ marginBottom: '3rem' }}>
                        <div className="Circle">
                          <img
                            src={ProfDoctor}
                            alt="Professional Indemnity for Doctors"
                          />
                        </div>
                        <h5>Professional Indemnity for Doctors</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="ProffessionalCompanies" className="link-style">

                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={ProfCompanies}
                            alt="Professional Indemnity for Companies"
                          />
                        </div>
                        <h5>Professional Indemnity for Companies</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="WorkmenCompensation" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img src={Workmen} alt="Workmen Compensation" />
                        </div>
                        <h5>Workmen Compensation</h5>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-4">
                    <Link to="DirectorsInsurance" className="link-style">
                      <div className="image-container-fluid hover-effect" style={{ marginBottom: '3rem' }}>
                        <div className="Circle">
                          <img
                            src={DirectorsOfficers}
                            alt="Directors & Office Insurance"
                          />
                        </div>
                        <h5>Directors & Office Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="MotorFleetInsurance" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={MotorFleetInsurance}
                            alt="Crime Insurance"
                          />
                        </div>
                        <h5>Motor Fleet Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="GeneralLiability" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={GeneralLiability}
                            alt="General Liability Insurance"
                          />
                        </div>
                        <h5>General Liability Insurance</h5>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <Link to="ProductLiability" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img
                            src={ProductLiabilty}
                            alt="Product Liability Insurance"
                          />
                        </div>
                        <h5>Product Liability Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                    <Link to="CyberInsurance" className="link-style">
                      <div className="image-container-fluid hover-effect">
                        <div className="Circle">
                          <img src={CyberInsurance} alt="Cyber Insurance" />
                        </div>
                        <h5>Cyber Insurance</h5>
                      </div>
                    </Link>
                  </div>
                  <div className="col-4">
                  <Link to="CrimeInsurance" className="link-style">
                    <div className="image-container-fluid hover-effect">
                      <div className="Circle">
                        <img src={CrimeInsurance} alt="Crime Insurance" />
                      </div>
                      <h5>Crime Insurance</h5>
                    </div>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section1
